<template>
  <div>
    <div class="row">
      <div class="col">
        <router-link to="/" class="link-back">
          <MaterialSvg
            class="icon-white"
            name="keyboard_backspace"
            :width="24"
          />
          {{ $t('detail.back') }}
        </router-link>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col">
        <MaterialSvg class="icon-cyaan" name="cancel" :width="80" />
        <h1 class="display-4 text-center">{{ $t('contact.error') }}</h1>
        <p class="lead text-center">
          {{ $t('contact.please') }}
          <router-link class="contact-link" to="Contact"> contact </router-link>
          {{ $t('contact.support') }}
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'OrderFailed',
};
</script>

<style scoped lang="scss">
h1 {
  margin-top: 0;
  margin-bottom: 0;
}
.icon-cyaan {
  display: block;
  margin: 0 auto;
  fill: $primary-color;
}
.contact-link {
  color: inherit;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    opacity: 0.9;
  }
}
</style>